"use strict";

exports.__esModule = true;
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactCropper = _interopRequireDefault(require("react-cropper"));
var _ = require("../");
var _components = require("../../components");
require("cropperjs/dist/cropper.css");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
class Picture extends _react.default.Component {
  constructor(props) {
    super(props);
    _defineProperty(this, "toggleModalDialog", () => {
      this.setState({
        modalDialogOpen: !this.state.modalDialogOpen
      });
    });
    _defineProperty(this, "handleDeletePicture", () => {
      this.props.onDrop();
      this.toggleModalDialog();
    });
    _defineProperty(this, "handleFileChange", event => {
      const file = event.target.files[0];
      this.setState({
        file: window.URL.createObjectURL(file)
      });
    });
    _defineProperty(this, "handleImageCrop", event => {
      const {
        onChange,
        localEntity
      } = this.props;
      let cropped;
      if (localEntity.toLowerCase() === "user") {
        cropped = this.cropper.getCroppedCanvas({
          width: 250,
          height: 250
        }).toDataURL();
      } else {
        cropped = this.cropper.getCroppedCanvas({
          width: 340,
          height: 250
        }).toDataURL();
      }
      const data = cropped.replace(/^data:image\/[a-z]+;base64,/, '');
      this.setState({
        data
      });
      onChange && onChange(data);
    });
    _defineProperty(this, "handleReset", () => {
      const {
        onChange
      } = this.props;
      onChange && onChange(null);
      this.setState({
        file: null
      });
    });
    _defineProperty(this, "handleSubmit", () => {
      let promiseReturned = this.props.onSubmit(this.state.data);
      this.setState({
        data: null,
        file: null
      });
    });
    _defineProperty(this, "render", () => {
      const {
        value,
        onChange,
        fetching,
        fetched,
        localEntity,
        row
      } = this.props;
      let imageType;
      let imageShape;
      let imageRatio;
      switch (localEntity.toLowerCase()) {
        case 'user':
          imageType = 'user';
          imageShape = 'round';
          imageRatio = 1 / 1;
          break;
        case 'category':
          imageType = 'category';
          imageShape = 'square';
          imageRatio = 1.36 / 1;
          break;
        case 'showroom':
          imageType = 'showroom';
          imageShape = 'square';
          imageRatio = 1.36 / 1;
          break;
        case 'contentfile':
          imageShape = 'square';
          imageRatio = 1.36 / 1;
          switch (row.Type) {
            case 3:
              imageType = 'pdf';
              break;
            case 4:
              imageType = 'image';
              break;
            case 6:
              imageType = 'video';
              break;
            default:
              imageType = 'image';
              break;
          }
          break;
        default:
          imageType = 'image';
          imageShape = 'square';
          imageRatio = 1.36 / 1;
          break;
      }
      return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("div", {
        className: `avatar-wrapper-large-${imageShape} mt-3 mb-3`
      }, fetching ? /*#__PURE__*/_react.default.createElement("div", {
        className: 'position-relative d-block pt-5',
        style: {
          height: '250px'
        }
      }, /*#__PURE__*/_react.default.createElement(_.Spinner, null)) : /*#__PURE__*/_react.default.createElement("div", {
        className: `position-relative d-block avatar-editor-${imageShape} avatar-${imageShape} avatar-${imageType}`,
        style: value ? {
          backgroundImage: `url(data:image/png;base64,${value})`
        } : {}
      }, this.state.file && /*#__PURE__*/_react.default.createElement(_reactCropper.default, {
        onInitialized: cropper => {
          this.cropper = cropper;
        },
        src: this.state.file,
        className: `avatar-cropper-${imageShape}`

        // Cropper.js options
        ,
        initialAspectRatio: imageRatio,
        guides: false,
        crop: this.handleImageCrop,
        viewMode: 3,
        dragMode: 'move',
        cropBoxMovable: false,
        cropBoxResizable: false,
        toggleDragModeOnDblclick: false,
        movable: true,
        autoCropArea: 1,
        minContainerWidth: 100
      }))), /*#__PURE__*/_react.default.createElement("div", {
        className: "row mt-3",
        style: {
          maxWidth: "20rem"
        }
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "col"
      }, /*#__PURE__*/_react.default.createElement("label", {
        htmlFor: 'Picture',
        className: 'btn btn-primary'
      }, /*#__PURE__*/_react.default.createElement("input", {
        id: 'Picture',
        type: 'file',
        className: 'd-none',
        onChange: this.handleFileChange
      }), "Choose file")), /*#__PURE__*/_react.default.createElement("div", {
        className: "col"
      }, fetching && /*#__PURE__*/_react.default.createElement("button", {
        className: "btn btn-primary",
        disabled: true
      }, /*#__PURE__*/_react.default.createElement("span", {
        className: "spinner-border spinner-border-sm",
        role: "status",
        "aria-hidden": "true"
      }), /*#__PURE__*/_react.default.createElement("span", {
        className: "sr-only"
      }, "Loading...")), !fetching && !onChange && value && !this.state.data && /*#__PURE__*/_react.default.createElement("button", {
        className: 'btn btn-primary',
        onClick: this.toggleModalDialog
      }, "Remove"), !fetching && !onChange && this.state.data && /*#__PURE__*/_react.default.createElement("button", {
        className: 'btn btn-primary',
        onClick: this.handleSubmit
      }, "Save"))), /*#__PURE__*/_react.default.createElement(_components.ModalDialog, {
        isOpen: this.state.modalDialogOpen,
        headerText: "You will remove your picture",
        bodyText: "Are you sure? This action cannot be undone.",
        buttonSecOnClick: this.toggleModalDialog,
        buttonSecText: "Cancel",
        buttonPrimOnClick: this.handleDeletePicture,
        buttonPrimText: "Remove"
      }));
    });
    this.state = {
      file: null,
      modalDialogOpen: false
    };
  }
}
var _default = exports.default = Picture;
module.exports = exports.default;